import {useTranslation} from "react-i18next";
import {useTheme} from "@mui/material";
import { CORPORATE, JLR,MID_TERM, OTHER, REPLACEMENT, RETAIL, SUBSCRIPTIONS, TOUR_OPERATORS
} from "../../finessecurity/component/Constants";


export const useClientTypeValues = () => {
    const {t} = useTranslation(['finessecurity'], {keyPrefix: 'blackList'});
    const theme = useTheme();

    const getClientTypeLabel = (status: number) => {
        switch (status) {
            case MID_TERM: return t('clientTypeValues.midTerm');
            case SUBSCRIPTIONS: return t('clientTypeValues.subscriptions');
            case JLR: return t('clientTypeValues.jlr');
            case RETAIL: return t('clientTypeValues.retail');
            case CORPORATE: return t('clientTypeValues.corporate');
            case REPLACEMENT: return t('clientTypeValues.replacement');
            case TOUR_OPERATORS: return t('clientTypeValues.tourOperators');
            case OTHER: return t('clientTypeValues.other');

            default : return '-'
        }
    };

    return {
        getClientTypeLabel
    }
}